import React, { useState, useEffect } from "react";
import { Input, Form, Switch, Spin, Select } from "antd";
import columns from "../../columns/Subadmin.js";
import ConfirmationModal from "../../components/global/modal/ConfirmationModal.jsx";
import TableWithSkeleton from "../../components/global/table/TableWithSkeleton.jsx";
import ModalComponent from "../../components/global/modal/ModalComponent.jsx"
import Edit from "../../assets/Edit.jsx";
import Account from "../../assets/Account.jsx";
import IbApproved from "../../assets/IbApproved.jsx";
import Kyc from "../../assets/Kyc.jsx";
import Inbox from "../../assets/Task.jsx";
import Withdraw from "../../assets/EmailTemplate.jsx";
import Wallet from "../../assets/wallet/Wallet.jsx";
import Ticket from "../../assets/support/Ticket.jsx";
import Sales from "../../assets/Sales.jsx"
import CashDeposit from "../../assets/CashDeposit.jsx"
import { AddSubadmin, GetAllSubadmin, GetSubadminsAndPermissionApi, AssignPermissionToSubAdminApi, UserStatusChangeApi, DeleteSubadminApi } from "../../api/request/subadmin.js";
import { GetAllCountryApi } from "../../api/request/common.js";
import toast from "react-hot-toast";
import LoadableButton from "../../components/buttons/LoadableButton.jsx";

import moment from "moment";
import Eye from "../../assets/Eye.jsx";
import Lock from "../../assets/auth/Lock.jsx";
import { ChangePasswordApi } from "../../api/request/users.js";
import Delete from "../../assets/Delete.jsx";
import Setting from "../../assets/Setting.jsx";

export default function Subadmin() {

    const [form] = Form.useForm();
    const [changePasswordForm] = Form.useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [isSubadminsAndPermissionLoading, setIsSubadminsAndPermissionLoading] = useState(false);
    const [subadminsAndPermissionData, setSubadminsAndPermissionData] = useState([]);
    const [isAddSubadminLoading, setIsAddSubadminLoading] = useState(false);
    const [isUpdateSubadminLoading, setIsUpdateSubadminLoading] = useState(false);
    const [isAddSubadmin, setIsAddSubadmin] = useState(false);
    const [isEditSubadmin, setIsEditSubadmin] = useState(false);
    const [isChangePassword, setIsChangePassword] = useState(false);
    const [initialValues, setInitialValues] = useState({ firstName: '', lastName: '', email: '', phoneNo: '', countryId: null });
    const [initialChangePasswordValue, setInitialChangePasswordValue] = useState({ newPassword: '', confirmPassword: '' });
    const [isStatusConfirmOpen, setIsStatusConfirmOpen] = useState(false);
    const [isStatusConfirmLoading, setIsStatusConfirmLoading] = useState(false);
    const [selectedSubAdmin, setSelectedUserAdmin] = useState(null);
    const [data, setData] = useState([]);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const primaryColor = (getComputedStyle(document.documentElement).getPropertyValue('--theme'))?.trim();
    const [countries, setCountries] = useState([]);
    const [isDeleteOpen, setIsDeleteOpen] = useState(false);
    const [isDeleteLoading, setIsDeleteLoading] = useState(false);
    const [isPasswordLoading, setIsPasswordLoading] = useState(false);


    const statusHandler = async (role) => {
        setSelectedUserId(role);
        setIsStatusConfirmOpen(true);
    }

    const getSubadmin = async () => {
        try {
            setIsLoading(true);
            let params = {

            };
            const { data } = await GetAllSubadmin(new URLSearchParams(params).toString());
            if (data?.success) {
                setData(data?.data?.map((item) => {
                    return {
                        ...item,
                        name: `${item?.firstName} ${item?.lastName}`,
                        createdDate: moment(item?.createdDate).format('DD-MM-YYYY, LT'),
                        status: ((<Switch onChange={() => statusHandler(item)} checkedChildren="On" unCheckedChildren="Off" checked={item?.isActive} />)),
                        actions: <div lassName="flex gap-2">
                            <button onClick={e => openEditHandler(item)} className="me-3"><Edit /></button>
                            <button onClick={e => changePasswordHandler(item)} className="me-3"><Setting /></button>
                            <button onClick={e => { setIsDeleteOpen(true); setSelectedUserId(item?.userId) }} ><Delete /></button>
                        </div>
                    }
                }));
            }
            setIsLoading(false);
        }
        catch (error) {
            setIsLoading(false);
        }
    }

    const statusChangeConfirm = async () => {
        try {
            setIsStatusConfirmLoading(true);

            const { data } = await UserStatusChangeApi({ userId: selectedUserId?.userId, isActive: !selectedUserId?.isActive });
            if (data?.success) {
                getSubadmin();
                toast.success(data?.message);
            } else {
                toast.error(data?.message);
            }

            setIsStatusConfirmLoading(false);
            setIsStatusConfirmOpen(false);
        } catch (error) {
            toast.error(error?.response?.data?.message);
            setIsStatusConfirmLoading(false);
        }
    }

    const handleSubmit = async (value) => {
        try {
            setIsAddSubadminLoading(true);
            const { data } = await AddSubadmin(value);
            if (data?.success) {
                toast.success(data?.message);
                form.resetFields();
                setIsAddSubadminLoading(false);
                setIsAddSubadmin(false);
                getSubadmin();
            }
            else {
                toast.error(data?.message);
                setIsAddSubadminLoading(false);
            }
        }
        catch (error) {
            toast.error(error?.response?.data?.message);
            setIsAddSubadminLoading(false);
        }
    }

    const handleSubadminChange = (moduleId, permission) => {
        setSubadminsAndPermissionData(prevModules =>
            prevModules.map(module =>
                module.moduleId === moduleId ? { ...module, permission } : module
            )
        );
    };

    const handleChangePassword = async (values) => {
        const { newPassword, confirmPassword } = values;
        const params = { userId: selectedUserId, newPassword };
        if (newPassword !== confirmPassword) {
            toast.error("New password and confirm password do not match.");
            return;
        }
        try {
            setIsPasswordLoading(true);
            const { data } = await ChangePasswordApi(params);
            if (data?.success) {
                toast.success(data?.message);
                changePasswordForm.resetFields();
                setIsPasswordLoading(false);
            } else {
                toast.error(data?.message);
                setIsPasswordLoading(false);
            }
            setIsChangePassword(false);
        } catch (error) {
            toast.error(error?.response?.data?.message);
            setIsPasswordLoading(false);
            setIsChangePassword(false);
        }
    }

    useEffect(() => {
        getSubadmin();
    }, []);

    const getCountries = async () => {
        try {
            const { data } = await GetAllCountryApi();
            if (data?.success) {
                setCountries(data?.data?.map((item) => ({ ...item, value: item?.id, label: item?.countryName })));
            }
        } catch (error) { }
    }

    const filterOption = (input, option) => {
        return (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
    }

    const openAddAdminModal = () => {
        getCountries();
        setIsAddSubadmin(true);
    }

    useEffect(() => {
        if (!isAddSubadmin) {
            form.resetFields();
        }
    }, [isAddSubadmin]);

    useEffect(() => {
        if (!isChangePassword) {
            changePasswordForm.resetFields();
            setInitialChangePasswordValue({ newPassword: '', confirmPassword: '' });
        }
    }, [isChangePassword]);

    const openEditHandler = (subadmin) => {
        getSubadminsAndPermissionById(subadmin?.userId);
        setSelectedUserAdmin(subadmin);
        setSelectedUserId(subadmin?.userId);
        setIsEditSubadmin(true);
    }

    const changePasswordHandler = (subAdminDetails) => {
        setSelectedUserId(subAdminDetails?.userId);
        setSelectedUserAdmin(subAdminDetails);
        setIsChangePassword(true);
    }

    const deleteHandler = async () => {
        try {
            setIsDeleteLoading(true);
            let UserId = selectedUserId;
            const { data } = await DeleteSubadminApi(UserId);
            if (data?.success) {
                toast.success(data?.message);
                setIsDeleteOpen(false);
                getSubadmin();
            }
            else {
                toast.error(data?.message);
            }
        }
        catch (error) {
            toast.error(error?.response?.data?.message);
            setIsDeleteLoading(false);
        }
    }

    const getSubadminsAndPermissionById = async (subadminId) => {
        try {
            setIsSubadminsAndPermissionLoading(true);
            const { data } = await GetSubadminsAndPermissionApi(subadminId);
            if (data?.success) {
                setSubadminsAndPermissionData(data?.data);
            }
            setIsSubadminsAndPermissionLoading(false);
        } catch (error) {
            setIsSubadminsAndPermissionLoading(false);
        }
    }

    const getIcons = (title) => {
        switch (title) {
            case 'Account':
                return <Account />;
            case 'Ticket':
                return <Ticket />;
            case 'Deposit':
                return <Wallet />;
            case 'Inbox':
                return <Withdraw />;
            case 'KYC':
                return <Kyc />;
            case 'Withdraw':
                return <Inbox />;
            case 'IB Manager':
                return <IbApproved />;
            case 'Sales':
                return <Sales />;
            case 'Internal Transfer':
                return <CashDeposit />;

        }
    }

    const updateSubadminsAndPermission = async () => {
        setIsUpdateSubadminLoading(true)
        try {
            let params = {
                moduleId: subadminsAndPermissionData?.filter((item) => item?.permission)?.map((item) => item?.moduleId) || [],
                userId: selectedUserId
            }
            const { data } = await AssignPermissionToSubAdminApi(params);
            if (data.success) {
                setIsUpdateSubadminLoading(false);
                toast.success(data.message)
                setIsEditSubadmin(false);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
            setIsUpdateSubadminLoading(false);
        }
    }

    return (
        <div>
            <div className="flex flex-col sm:flex-row sm:justify-end">
                <div className="flex">

                    <div>
                        <button
                            className="flex items-center bg-primary text-sm text-white font-medium uppercase px-6 py-2 rounded-lg themeHover  duration-400"
                            onClick={openAddAdminModal}
                            size="large"
                        >
                            <img
                                src="assets/icons/add_icon.svg"
                                alt="icon"
                                className="mr-2 mt-1"
                                width={15}
                            />
                            Add Subadmin
                        </button>
                    </div>
                </div>
            </div>

            <div className="my-6">
                <div className="border border-gray-200 rounded-xl overflow-hidden bg-white">
                    <TableWithSkeleton columns={columns} data={data} loading={isLoading} />
                </div>
            </div>

            <ConfirmationModal
                isOpen={isStatusConfirmOpen}
                setIsOpen={setIsStatusConfirmOpen}
                message='Are you sure to change the Subadmin status?'
                onConfirm={statusChangeConfirm}
                isLoading={isStatusConfirmLoading}
                loadingLabel='Changing status...'
            />

            {/* ---- Delete modal ---- */}
            <ConfirmationModal
                isOpen={isDeleteOpen}
                setIsOpen={setIsDeleteOpen}
                message='Are you sure you want to remove this sub admin?'
                onConfirm={deleteHandler}
                isLoading={isDeleteLoading}
                loadingLabel='Deleting sub admin...'
            />

            {/* Add subadmin */}
            <ModalComponent isOpen={isAddSubadmin} setIsOpen={setIsAddSubadmin} title={<div className="font-bold text-lg">Add User</div>} onCancel={() => setIsAddSubadmin(false)} width={800}>
                <Form
                    className="w-full"
                    autoComplete="off"
                    form={form}
                    initialValues={initialValues}
                    onFinish={handleSubmit}
                >
                    <div className="grid sm:grid-cols-2 lg:grid-cols-2 gap-5">
                        <div className="input-white">
                            <label className="text-base text-[#2F2B3DCC] font-medium">
                                First Name
                            </label>
                            <Form.Item name="firstName" rules={[{ required: true, message: "Please enter first name." }]}>
                                <Input placeholder="First name" className="mt-1 w-full py-2" />
                            </Form.Item>
                        </div>
                        <div className="input-white">
                            <label className="text-base text-[#2F2B3DCC] font-medium">
                                Last Name
                            </label>
                            <Form.Item name="lastName" rules={[{ required: true, message: "Please enter last name." }]}>
                                <Input placeholder="Last name" className="mt-1 w-full py-2" />
                            </Form.Item>
                        </div>
                        <div className="input-white">
                            <label className="text-base text-[#2F2B3DCC] font-medium">
                                Primary Email
                            </label>
                            <Form.Item name="email" rules={[{ required: true, type: "email", message: "Please enter valid email." }]}>
                                <Input placeholder="Primary email" className="mt-1 w-full py-2" />
                            </Form.Item>
                        </div>
                        <div className="input-white">
                            <label className="text-base text-[#2F2B3DCC] font-medium">
                                Phone No.
                            </label>
                            <Form.Item
                                name="phoneNo"
                                rules={[{ required: true, message: "Please enter valid phone number." }]}
                            >
                                <Input
                                    type="number"
                                    placeholder="Phone no."
                                    className="mt-1 w-full py-2"
                                />
                            </Form.Item>
                        </div>
                        {/* <div className="ant-select-selector-white">
                                <p className="text-base text-[#2F2B3DCC] font-medium">Select Your Country</p>
                                <Form.Item name="countryId" rules={[{ required: true, message: 'Please select a country.' }]}>
                                    <Select className="mt-1" showSearch filterOption={filterOption} options={countries} placeholder='Select a country' />
                                </Form.Item>
                            </div> */}

                    </div>
                    <div className="flex justify-end mt-8">
                        <LoadableButton
                            className="bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover  duration-500"
                            disabled={isAddSubadminLoading}
                            type="Submit"
                            lable="Submit"
                            isLoading={isAddSubadminLoading}
                            loadingLable="Adding subadmin..."
                        />
                    </div>
                </Form>
            </ModalComponent>

            {/* Edit subadmin */}
            <ModalComponent isOpen={isEditSubadmin} setIsOpen={setIsEditSubadmin} title={<div className="font-bold text-lg">List of Permission </div>} onCancel={() => setIsEditSubadmin(false)} width={650}>
                {
                    isSubadminsAndPermissionLoading ? (
                        <div className="flex justify-center flex-col my-[10%]">
                            <Spin size="large" />
                            <p className="primary text-center mt-2">Loading...</p>
                        </div>
                    ) : (
                        <div>
                            <div className="grid lg:grid-cols-4 sm:grid-cols-3 grid-cols-2 gap-4 mt-2 px-4">
                                {subadminsAndPermissionData.map((item, index) => (
                                    <div key={index} className="h-[100px] relative" onClick={() => handleSubadminChange(item?.moduleId, !item.permission)} >
                                        <div className={`border rounded p-4 h-full flex flex-col justify-center items-center cursor-pointer duration-300 ${item?.permission ? " border-primary" : ""}`}>
                                            {
                                                item?.permission &&
                                                <div className="h-[10px] w-[10px] rounded-full absolute top-2 left-2">
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} className="size-4" stroke={primaryColor} >
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                                                    </svg>

                                                </div>
                                            }
                                            <div>{getIcons(item?.moduleName)}</div>
                                            <p className="text-center subadmins-title ">{item?.moduleName}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className=" text-center mt-6">
                                <LoadableButton
                                    className="bg-primary text-base text-white font-medium uppercase px-9 py-2 rounded-lg themeHover duration-400"
                                    disabled={isUpdateSubadminLoading}
                                    type="Submit"
                                    lable="Save"
                                    isLoading={isUpdateSubadminLoading}
                                    loadingLable="Updating subadmin..."
                                    onClick={updateSubadminsAndPermission}
                                />
                            </div>
                        </div>
                    )
                }
            </ModalComponent>

            <ModalComponent isOpen={isChangePassword} setIsOpen={setIsChangePassword} title='Change Password' >
                {/* {selectedSubAdmin === null ? (
                        <div className="flex justify-center flex-col items-center my-10">
                            <Spin size="large" />
                            <p className="primary text-center mt-2">Loading...</p>
                        </div>
                    ) : (
                        <div className="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4">
                            <div>
                                <p className='text-base font-normal '>First Name</p>
                                <p className='text-xl primary font-semibold  mt-2'>{selectedSubAdmin?.firstName}</p>
                            </div>
                            <div>
                                <p className='text-xl primary font-semibold  mt-2'>Last Name</p>
                                <p className='text-xl primary font-semibold  mt-2'>{selectedSubAdmin?.lastName}</p>
                            </div>
                            <div>
                                <p className='text-base font-normal '>Email</p>
                                <p className='text-xl primary font-semibold  mt-2'>{selectedSubAdmin?.email}</p>
                            </div>
                            <div>
                                <p className='text-base font-normal '>Phone No.</p>
                                <p className='text-xl primary font-semibold  mt-2'>{selectedSubAdmin?.phoneNo}</p>
                            </div>
                            <div>
                                <p className='text-base font-normal '>Created By</p>
                                <p className='text-xl primary font-semibold  mt-2'>{selectedSubAdmin?.createdBy}</p>
                            </div>
                            <div>
                                <p className='text-base font-normal '>Created Date</p>
                                <p className='text-xl primary font-semibold  mt-2'> {moment(selectedSubAdmin?.createdDate).format("DD-MM-YYYY, hh:mm A")}</p>
                            </div>
                        </div>
                    )} */}
                <Form autoComplete="off" initialValues={initialChangePasswordValue} onFinish={handleChangePassword} form={changePasswordForm}>
                    <div className="p-5 grid grid-cols-1 gap-6">
                        <div>
                            <p className="mb-1">New Password</p>
                            <Form.Item name="newPassword" hasFeedback rules={[{ required: true, message: "Please input your new password!" },]} >
                                <Input.Password size="large" placeholder="New Password" prefix={<Lock />} />
                            </Form.Item>
                        </div>
                        <div >
                            <p className="mb-1">Confirm Password</p>
                            <Form.Item dependencies={['newPassword']} hasFeedback name="confirmPassword" rules={[{
                                required: true, message: "Please confirm your new password!",
                            },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue('newPassword') === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('The new password that you entered do not match!'));
                                },
                            }),]}>
                                <Input.Password size="large" placeholder="Confirm Password" prefix={<Lock />} />
                            </Form.Item>
                        </div>
                        <div >
                            <LoadableButton
                                type="submit"
                                className="w-full text-base font-medium py-2 px-2 rounded-lg text-white bg-primary themeHover"
                                lable="Change Password"
                                isLoading={isPasswordLoading}
                                loadingLable="Updating..."
                            />
                        </div>
                    </div>
                </Form>
            </ModalComponent>


        </div>
    );
}